import { render, staticRenderFns } from "./RTPNormList.vue?vue&type=template&id=7cf90b72&"
import script from "./RTPNormList.vue?vue&type=script&lang=js&"
export * from "./RTPNormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports